  // TODO: After this fills out a little, evaluate whether it is similar enough to
// PropertyInformationHeader to merge into a single common component.
// Possibly, it would make sense to make each icon a "dumb" component and share those.

import React from 'react';
import PropTypes from 'prop-types';

import { details as feature } from '../../../featureConfig';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import { getAreaPdfLink } from '../../../ajax/endpoints';
import { getAreaImages } from '../../../utils/attachmentUtils';
import svgInline from '../../SvgInline/SvgInline';

import reportsIcon from '../../../shared/assets/report-icon.png';
import specialReportIconDefault from '../../../shared/assets/special-reports.png';
import specialReportIconDemographics from '../../../shared/assets/icon-demographics.png';
import videosIcon from '../../../shared/assets/icon-videos.png';
import photosIcon from '../../../shared/assets/icon-photos.png';
import printIcon from '../../../shared/assets/icon-print.png';
import filesIcon from '../../../shared/assets/icon-attachment.png';
import shareIcon from '../../../shared/assets/icon-mail.png';
import workforceIcon from '../../../shared/assets/icon-workforce.svg';

import ShareModal from '../../Modal/ShareModal/ShareModal';
import DownloadModal from '../../Modal/DownloadModal/DownloadModal';
import SpecialAttachmentsDownloadModal from '../../Modal/DownloadModal/SpecialAttachmentsDownloadModal';
import VideoModal from '../../Modal/VideoModal/VideoModal';

import { storage } from '../../../config';

export function AreaInformationHeaderComponent({
  handleModalClick,
  handleWorkforceClick,
  area,
  overview,
  layer,
  organizationId,
  showShareModal,
  showDownloadModal,
  showSpecialDownloadModal,
  showSlideshow,
  showModal,
  viewer,
}) {
  const attachments = (overview.details && overview.details.attachments) || {};
  const hasFiles = (attachments && attachments.attachments) ? attachments.attachments.length : 0;
  const videos = (attachments && attachments.videos) || [];
  const images = getAreaImages(overview);
  const imagesLength = images.length;
  const pdfLink = getAreaPdfLink(area, layer, organizationId);
  const hasSpecficReports = (overview.details && overview.details.attachments
    && overview.details.attachments.specialAttachments
    && overview.details.attachments.specialAttachments.length > 0);
  const specificReportsLength
    = hasSpecficReports ? overview.details.attachments.specialAttachments.length : 0;

  const showESRIReports = viewer.adminSettings.showESRIReports || false;
  const specialReportsLabel = viewer.adminSettings.specialCommAttachmentLabel !== '' ? viewer.adminSettings.specialCommAttachmentLabel : 'Specific Reports';
  let specialReportsIconSelected = specialReportIconDefault;
  if (viewer.adminSettings.specialCommAttachmentIconSelected === 0) {
    specialReportsIconSelected = specialReportIconDefault;
  } else if (viewer.adminSettings.specialCommAttachmentIconSelected === 1) {
    specialReportsIconSelected = specialReportIconDemographics;
  } else if (viewer.adminSettings.specialCommAttachmentIconSelected === 2 && viewer.adminSettings.specialCommAttachmentIcon !== '') {
    specialReportsIconSelected = `${storage.cloudStoragePath}/${viewer.adminSettings.specialCommAttachmentIcon}`;
  }
  let countyNames = [];
  if (overview.details.counties) {
    countyNames = overview.details.counties.map(county => {
      let name = county.basicInfo.about.name;

      if (layer === 'regions') {
        name += `(${county.basicInfo.about.state})`;
      }

      return name;
    });
  }
  countyNames.sort();
  return (
    <div className="detail-header">
      <div className="detail-header-left">
        <h1>
          {overview.details.name}
          {layer === 'counties' && ' County'}
          {overview.details.state && `, ${overview.details.state}`}
          {
            (overview.details.counties && overview.details.counties.length > 0) &&
            layer !== 'counties' &&
            <small>
              <br />
              {overview.details.counties.length === 1 ? 'County:' : 'Counties:'}
              {' '}
              {countyNames.join(', ')}
            </small>
          }
        </h1>
      </div>
      <div className="detail-header-right">
        <ShareModal />
        <DownloadModal files={attachments.attachments} />
        <SpecialAttachmentsDownloadModal
          modalHeader={specialReportsLabel}
          files={attachments.specialAttachments}
        />
        <ul className="property-toolbar">
          {hasSpecficReports &&
            <li className="badged">
              <a
                href={specificReportsLength === 0 ? '#' : ''}
                onClick={e => {
                  e.preventDefault();
                  if (hasSpecficReports) {
                    showSpecialDownloadModal(area._id);
                  }
                }}
              ><img src={specialReportsIconSelected} alt="" /><div>{specialReportsLabel}</div></a>
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <span className="badge">{specificReportsLength}</span>
              </ViewerPrimaryColorUserStyle>
            </li>
          }
          {overview.details.laborForceUrls && viewer.adminSettings.chmuraEmbed &&
            <li className="extra-width">
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  handleWorkforceClick();
                }}
              >
                {svgInline(workforceIcon, {
                  width: '33px',
                  height: '35px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                })}
                <div>Workforce</div>
              </a>
            </li>
          }
          {showESRIReports &&
            <li>
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  handleModalClick();
                }}
              >
                <img src={reportsIcon} alt="" /><div>ESRI Reports</div></a></li>
          }

          <li className="badged">
            <a
              href={videos.length === 0 ? '#' : ''}
              onClick={e => {
                e.preventDefault();
                if (videos.length) {
                  showModal(`video-header-${area._id}`);
                }
              }}
            >
              <img src={videosIcon} alt="" /><div>Videos</div>
            </a>
            <VideoModal id={area._id} urlList={videos} modalName={'video-header'} />
            <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
              <span className="badge">{videos.length}</span>
            </ViewerPrimaryColorUserStyle>
          </li>
          {feature.photos &&
            <li className="badged">
              <a
                href={imagesLength === 0 ? '#' : ''}
                onClick={e => {
                  e.preventDefault();
                  if (imagesLength) {
                    showSlideshow(area._id);
                  }
                }}
              >
                <img src={photosIcon} alt="" />
                <div>Photos</div>
              </a>
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <span className="badge">{imagesLength}</span>
              </ViewerPrimaryColorUserStyle>
            </li>
          }
          {feature.print &&
            <li><a target="_blank" rel="noopener noreferrer" href={pdfLink}><img src={printIcon} alt="" /><div>Print Brochure</div></a></li>
          }
          {feature.files &&
            <li className="badged">
              <a
                href={hasFiles === 0 ? '#' : ''}
                onClick={e => {
                  e.preventDefault();
                  if (hasFiles) {
                    showDownloadModal(area._id);
                  }
                }}
              ><img src={filesIcon} alt="" /><div>Files</div></a>
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <span className="badge">{hasFiles}</span>
              </ViewerPrimaryColorUserStyle>
            </li>
          }
          {feature.share &&
            <li><a tabIndex="0" onClick={showShareModal}><img src={shareIcon} alt="" /><div>Share</div></a></li>
          }
        </ul>
      </div>
    </div>
  );
}

AreaInformationHeaderComponent.propTypes = {
  area: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    _id: PropTypes.string,
  }),
  overview: PropTypes.object,
  layer: PropTypes.string,
  handleModalClick: PropTypes.func,
  handleWorkforceClick: PropTypes.func,
  organizationId: PropTypes.string,
  showShareModal: PropTypes.func,
  showSlideshow: PropTypes.func.isRequired,
  showDownloadModal: PropTypes.func.isRequired,
  showSpecialDownloadModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default AreaInformationHeaderComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaInformationContainer/AreaInformationHeader.js